import type { Signal } from '@angular/core';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { Observable } from 'rxjs';

import { CheckUserExistsResult } from '../../models';
import { CheckUserExistsByEmail, ResetUserExistenceCheck } from '../actions';
import { MemberSelectors } from '../selectors';

@Injectable()
export class MemberStoreService {
  constructor(private store: Store) {}

  get userExists$(): Observable<boolean> {
    return this.store.select(MemberSelectors.isUserExists);
  }

  get isCheckingUserExistence(): Signal<boolean> {
    return this.store.selectSignal(MemberSelectors.isCheckingUserExistence);
  }

  get isCheckingUserExistence$(): Observable<boolean> {
    return this.store.select(MemberSelectors.isCheckingUserExistence);
  }

  get userExistenceCheckCompleted$(): Observable<boolean> {
    return this.store.select(MemberSelectors.isUserExistenceCheckCompleted);
  }

  get userExistenceCheckError$(): Observable<string> {
    return this.store.select(MemberSelectors.userExistenceCheckError);
  }

  get userExistenceStatus(): Signal<CheckUserExistsResult> {
    return this.store.selectSignal(MemberSelectors.userExistenceStatus);
  }

  @Dispatch()
  checkUserExistsByEmail = (email: string, selectedCompanyId: string | null) =>
    new CheckUserExistsByEmail(email, selectedCompanyId);

  @Dispatch()
  resetUserExistenceCheck = () => new ResetUserExistenceCheck();
}
